import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import throttle from 'lodash/throttle';
import API from '../create/api';
import * as helper from '../../helper/index';

export default function Company({ onChange, defaultValue = null, disabled = false }: any) {
  const [loading, setLoading] = React.useState(false);
  const [options, setOptions]: any = React.useState([]);
  const [inputValue, setInputValue] = React.useState('');

  const fetch_companies = React.useMemo(() => {
    setLoading(true);
    return throttle(async (inputValue) => {
      await API.getAll(`${process.env.REACT_APP_API_SERVER}/companies?name_contains=${inputValue}&_limit=50`)
        .then((res: any) => {
          const companies = res
            .filter((c: any) => {
              return c?.user?.confirmed;
            })
            .sort((a: any, b: any) => {
              const nameA = a.name.toUpperCase();
              const nameB = b.name.toUpperCase();
              if (nameA < nameB) return -1;
              if (nameA > nameB) return 1;
              return 0;
            })
            .map((c: any) => {
              return {
                label: c.name,
                value: c.id,
              };
            });
          setOptions(companies as any[]);
        })
        .catch((e) => {
          helper.axiosErrorHandling(e);
        })
        .finally(() => {
          setLoading(false);
        });
    }, 200);
  }, []);

  React.useEffect(() => {
    fetch_companies(inputValue);
  }, [inputValue, fetch_companies]);

  return (
    <Autocomplete
      disabled={disabled ?? loading}
      defaultValue={defaultValue}
      isOptionEqualToValue={(option, value) => option.label === value.label}
      getOptionLabel={(option: any) => option.label}
      options={options}
      loading={loading}
      onChange={(e, newValue) => {
        onChange(newValue);
      }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          fullWidth
          label="Company"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}
